import { render, staticRenderFns } from "./SearchProductLots.vue?vue&type=template&id=19cd95e5&scoped=true&"
import script from "./SearchProductLots.vue?vue&type=script&lang=js&"
export * from "./SearchProductLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd95e5",
  null
  
)

export default component.exports